import { Delete, Done } from "@mui/icons-material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useContext, useState } from "react";
import { connect } from "react-redux";
import { selectProject } from "../../../redux/selectors/editor";
import { ConfirmContext } from "../../../utility/ConfirmProvider";
import {getInitialStyle, StyleOptions} from "../../../utility/Style";
import { FirebaseContext } from "../../firebase/FirebaseProvider";
import { Sheet } from "../GridView";
import FormatRule, { RuleDefinition } from "./FormatRule";
import { FormattingStyleOptions } from "./StyleOptions";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(1),
        gap: theme.spacing(1)
    }
}));

interface Props
{
    ruleId: string,
    sheetId: string
    sheet: Sheet,
    project: string
}

export interface ConditionalFormattingDefinition
{
    formatStyle: StyleOptions
    rule: RuleDefinition
}

function ConditionalFormattingItem({ ruleId, sheetId, sheet, project }: Props)
{
    const classes = useStyles();
    const [formatStyle, setFormatStyle] = useState<StyleOptions>(ruleId ? sheet.conditionalFormatting[ruleId].formatStyle : getInitialStyle());

    const confirm = useContext(ConfirmContext);
    const { set, remove } = useContext(FirebaseContext);

    const [rule, setRule] = useState<RuleDefinition>(ruleId ? sheet.conditionalFormatting[ruleId].rule : { columnId: "", operator: "empty", value: "" });

    const handleClick = () =>
    {
        set(`sheets/${project}/${sheetId}/conditionalFormatting/${ruleId}`, { formatStyle, rule });
    }

    const handleClickDelete = () =>
    {
        confirm(<Typography variant={"body2"}>Are you sure you want to delete this conditional format?</Typography>)
            .then(() => remove(`sheets/${project}/${sheetId}/conditionalFormatting/${ruleId}`))
            .catch(() => { });
    }

    return <Box className={classes.container}>
        <Typography>Rule</Typography>
        <Divider />
        <FormatRule sheet={sheet} rule={rule} onRuleChanged={setRule} />

        <Typography>Style</Typography>
        <Divider />
        <FormattingStyleOptions formatStyle={formatStyle} setFormatStyle={setFormatStyle} />

        <IconButton onClick={handleClick}>
            <Done />
        </IconButton>
        <IconButton onClick={handleClickDelete}>
            <Delete />
        </IconButton>
    </Box>
}

const mapStateToProps = (store: never) => ({
    project: selectProject(store)
});
export default connect(mapStateToProps, {
})(ConditionalFormattingItem);